import React, { useState, useEffect } from "react";
import { Avatar } from "@material-ui/core";
import CreateMessage from "./createMessage";
const ChatView = ({
  chat,
  user,
  selectedChat,
  newChatFormShow,
  messageRead,
  submitMessage,
  userIsTyping,
  db,
}) => {
  useEffect(() => {
    const container = document.getElementById("chat-container");
    container.scrollTo(0, container.scrollHeight);
    async function getfriend() {
      await db
        .collection("users")
        .doc(chat.users.filter((f) => f !== user)[0])
        .get()
        .then((doc) => {
          setFriend(doc.data());
        });
    }
    if (chat) getfriend();
  }, [chat, user, db]);

  const [friend, setFriend] = useState({ name: "", photo: "" });
  const [msgCount, setMsgCount] = useState(15);

  const loadPreviousChat = (m) => {
    if (m > msgCount) {
      let newCount = msgCount + 15;
      if (newCount > m) {
        setMsgCount(m);
        document.getElementById("load-chat").style.display = "none";
      } else setMsgCount(newCount);
    }
  };

  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const time = hours + ":" + minutes + " " + ampm;
    return time;
  };

  const iAmSender = () => {
    return chat.messages[chat.messages.length - 1].sender === user;
  };

  const typingAnimation = () => {
    return (
      <div className="typingAnimation">
        <div className="typing__dot"></div>
        <div className="typing__dot"></div>
        <div className="typing__dot"></div>
        <div className="typing__dot"></div>
        <div className="typing__dot"></div>
      </div>
    );
  };

  return (
    <div className="chatView" id="chatView">
      <div className="header">
        {chat ? (
          <span>
            Your Conversation with
            <span>{friend.name}</span>
          </span>
        ) : (
          <span> Select a Chat to View </span>
        )}
      </div>
      <div id="chat-container">
        {chat && (chat.messages.length > 15) && (
          <div
            id="load-chat"
            className="load-chat"
            onClick={() => loadPreviousChat(chat.messages.length)}
          >
            Load Previous Chat
          </div>
        )}
        {chat &&
          chat.messages
            .slice(chat.messages.length - msgCount, chat.messages.length)
            .map((m, i) => (
              <div key={i} className={m.sender === user ? "you" : "friend"}>
                <span className="msg-body">
                  {m.message.split("\n").map((str, i) => (
                    <p key={i} className="chat-msg">
                      {str}
                    </p>
                  ))}
                </span>
                {m.image && (
                  <img className="chat-image" src={m.image} alt="shared" />
                )}
                <span className={m.sender === user ? "span__r" : "span__l"}>
                  {new Date(m.time).toString().slice(4, 10) +
                    " , " +
                    formatTime(new Date(m.time))}
                </span>
              </div>
            ))}
      </div>
      <div className="chat-indicators">
        {chat &&
          chat.receiverHasRead &&
          (chat.isTyping.find((f) => f.userId !== user).typing ? (
            <div className="chat-typing"> {typingAnimation()} </div>
          ) : (
            <div className="chat-seen">
              {iAmSender() && (
                <Avatar
                  alt="seen"
                  style={{ width: "2rem", height: "2rem" }}
                  src={friend.photo}
                />
              )}
            </div>
          ))}
      </div>

      <div className="chat__message">
        {selectedChat !== null && !newChatFormShow && (
          <CreateMessage
            chatIndex={selectedChat}
            read={messageRead}
            send={submitMessage}
            userIsTyping={userIsTyping}
            user={user}
          />
        )}
      </div>
    </div>
  );
};

export default ChatView;
